module.exports = __webpack_public_path__ + "media/images/talent/case2-badge-bd8e7a7f2885b91fb76ee1552a413a12.png";